










































































import { Component, Vue } from 'vue-property-decorator';
import FilePicker from '@/components/FilePicker.vue';
import ListPicker from '@/components/ListPicker.vue';
import { DxCheckBox } from 'devextreme-vue/check-box';

@Component({
  components: {
    FilePicker,
    ListPicker,
    DxCheckBox
  }
})
export default class CdrUploadPage extends Vue {
    public datarow = {
      uploadEntry: void 0,
      fornitoriRecord: void 0,
      testMode: true
    };

    /**
     *  Contiene il risultato dell'elaborazione cdr.
     */
    public cdrProcessFileResult: any = null;

    constructor() {
        super();
    }

    public downloadZip() {
      Vue.$svc.downloadCdrFile(this.cdrProcessFileResult.fileIdentifier);
    }

    public async submitFile() {
        await Vue.$svc.displayAlert('Attenzione', `
          Potrebbe essere necessario qualche minuto per elaborare il file. Non chiudere la finestra fino al termine della procedura.
        `);
        const res = await Vue.$svc.genericCall('post', 'cdrUpload', {
            ...this.datarow
        });
        console.info('-> submit res was', res);
        if (res && res.cdrProcessFileResult) {
          await Vue.$svc.displayAlert('Elaborazione terminata.', `
            Elaborazione terminata con esito positivo.
          `);
          this.cdrProcessFileResult = res.cdrProcessFileResult;
        }
    }
}
